module.exports = __webpack_public_path__ + "static/media/morteros-ico.c58ed73c.svg";